import { render, staticRenderFns } from "./InfoAttentionList.vue?vue&type=template&id=308d8dc8&scoped=true&"
import script from "./InfoAttentionList.vue?vue&type=script&lang=js&"
export * from "./InfoAttentionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d8dc8",
  null
  
)

export default component.exports